import { z } from 'zod'

export const filtersValuesSchema = z.object({
  attributes: z.record(z.string(), z.any()).optional(),
  attributeGroupId: z.string().optional().nullable(),
  searchTerm: z.string().optional(),
  orderBy: z.record(z.string(), z.enum(['asc', 'desc'])).optional(),
  page: z.coerce.number().optional(),
  statusFilter: z.enum(['ready', 'in_review', 'both']).optional(),
  view: z.enum(['list', 'grid']).optional(),
})

export type FiltersValues = z.infer<typeof filtersValuesSchema>
